export const SPEECH_LANGUAGES = [
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'de', label: 'Deutsch' },
  { code: 'it', label: 'Italiano' },
  { code: 'pt', label: 'Português' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'ar', label: 'العربية' },
  { code: 'zh', label: '中文' },
  { code: 'ja', label: '日本語' },
  { code: 'ko', label: '한국어' },
  { code: 'ru', label: 'Русский' },
  { code: 'uk', label: 'Українська' },
] as const;
export type SpeechLanguage = (typeof SPEECH_LANGUAGES)[number]['code'];
export function isSpeechLanguage(value: string | null): value is SpeechLanguage {
  return SPEECH_LANGUAGES.some(({ code }) => code === value);
}
export function defaultSpeechLanguage(locales: readonly string[]): SpeechLanguage {
  for (const locale of locales) {
    const code = locale.toLowerCase().split(/[-_]/)[0] ?? '';
    if (isSpeechLanguage(code)) return code;
  }
  return 'en';
}
